/**
 * Nav interactions for the mdh header.
 */
import { initNavSearch } from './search/nav-search.js';
import { initNavLanguage } from './nav-language.js';
import { initNavMobile } from './mobile/nav-mobile.js';
import { initNavPanels } from './mega/nav-panels.js';
import { initNavMega } from './mega/nav-mega.js';

export function initNav() {
  initHeaderScroll();
  initNavSearch();
  initNavLanguage();
  initNavMobile();
  initNavPanels();
  initNavMega();
  initCookieLink();
}

// The footer Cookies link opens the consent dialog via WebToffee's revisit button.
function initCookieLink() {
  const link = document.querySelector('.mdf .cookie-link a');
  if (!link) {
    return;
  }
  link.addEventListener('click', (event) => {
    const revisitButton = document.querySelector('.wcc-btn-revisit');
    if (revisitButton) {
      event.preventDefault();
      revisitButton.click();
    }
  });
}

// Hide on scroll down past 150px, reveal on scroll up.
function initHeaderScroll() {
  const header = document.querySelector('.mdh');
  if (!header) {
    return;
  }
  let prevScrollPos = window.pageYOffset;
  const delay = 30;
  let counter = 0;
  const fullWidthHero = document.querySelector('[fullwidth-hero="true"]');

  window.addEventListener('scroll', () => {
    const currentScrollPos = window.pageYOffset;

    // Never hide the bar while the mobile menu or a submenu panel is open.
    if (header.classList.contains('mdh--menu-open') || header.classList.contains('mdh--panel-open')) {
      header.classList.remove('mdh--hidden');
      prevScrollPos = currentScrollPos;
      return;
    }

    if (window.scrollY > 150) {
      if (prevScrollPos > currentScrollPos) {
        header.classList.remove('mdh--hidden');
        counter = 0;
      } else if (counter > delay && prevScrollPos < currentScrollPos) {
        header.classList.add('mdh--hidden');
      }
      counter++;
      prevScrollPos = currentScrollPos;
    } else {
      header.classList.remove('mdh--hidden');
    }

    if (fullWidthHero) {
      header.classList.toggle('mdh--blur', window.scrollY > 50);
    }
  });
}
